var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrived(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7138 0.5C10.6102 0.5 5.64453 5.46566 5.64453 11.5693C5.64453 18.9724 16.7298 33.5 16.7298 33.5C16.7298 33.5 20.0797 29.0021 22.5992 24.7375C26.039 18.9155 27.7831 14.485 27.7831 11.5693C27.7832 5.46566 22.8175 0.5 16.7138 0.5Z",
    fill: "#ED3A42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7139 0.5V33.479C16.7242 33.4926 16.7298 33.5 16.7298 33.5C16.7298 33.5 20.0797 29.0021 22.5992 24.7375C26.039 18.9155 27.7831 14.485 27.7831 11.5693C27.7832 5.46566 22.8175 0.5 16.7139 0.5Z",
    fill: "#E7242C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7138 4.88379C13.0113 4.88379 9.99902 7.89601 9.99902 11.5985C9.99902 15.301 13.0113 18.3132 16.7138 18.3132C20.4163 18.3132 23.4286 15.301 23.4286 11.5985C23.4286 7.89601 20.4163 4.88379 16.7138 4.88379Z",
    fill: "#FFDA2D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7139 4.88379V18.3132C20.4164 18.3132 23.4287 15.301 23.4287 11.5985C23.4287 7.89601 20.4164 4.88379 16.7139 4.88379Z",
    fill: "#FDBF00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5026 14.8326L13.4702 12.6358L14.6047 11.0699L16.1462 12.1868L18.6365 9.08252L20.1447 10.2925L16.5026 14.8326Z",
    fill: "#ED3A42"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6363 9.08252L16.7139 11.479V14.569L20.1446 10.2925L18.6363 9.08252Z",
    fill: "#E6242C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrived);
export default __webpack_public_path__ + "static/media/arrived.b34a119c851ba48210ac19f5dd4d5996.svg";
export { ForwardRef as ReactComponent };